<div class="container-div">
  
    <div class="row justify-content-center py-5">
      <div class="col-md-8">
        <div class="d-flex justify-content-center" style="margin-bottom: 10px;">
          <svg width="72" height="71" viewBox="0 0 72 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="35.9962" cy="35.3419" r="35.2853" fill="#23A26D" fill-opacity="0.12"/>
            <path d="M35.984 14.4678C24.4821 14.4678 15.1094 23.8405 15.1094 35.3424C15.1094 46.8444 24.4821 56.2171 35.984 56.2171C47.486 56.2171 56.8587 46.8444 56.8587 35.3424C56.8587 23.8405 47.486 14.4678 35.984 14.4678ZM45.9621 30.5413L34.1262 42.3772C33.8339 42.6694 33.4373 42.8364 33.0198 42.8364C32.6023 42.8364 32.2057 42.6694 31.9135 42.3772L26.0059 36.4697C25.4006 35.8643 25.4006 34.8623 26.0059 34.2569C26.6113 33.6516 27.6133 33.6516 28.2187 34.2569L33.0198 39.0581L43.7494 28.3285C44.3548 27.7232 45.3568 27.7232 45.9621 28.3285C46.5675 28.9339 46.5675 29.915 45.9621 30.5413Z" fill="#23A26D"/>
            </svg>
            
        </div>
        <!-- <p class="text-center fs-4 mb-0">Successful</p> -->
        <h6 style="color: #474747; font-weight: 700; text-align: center; margin-bottom: 10px;">Success</h6>
        <p class="text-center" style="word-wrap: break-word;">{{data.successMessage}}</p>
  
      </div>
    </div>

  <div class="close-btn" (click)="closeModal()">
    Done
  </div>
</div>
